import { TenantDetailsFormStateTenant as TenantDetailsFormStateTenant } from './TenantDetailsFormStateTenant';
import { TenantDetailsFormStateMicrosoftPartner } from './TenantDetailsFormStateMicrosoftPartner';

export class TenantDetailsFormState {
  tenant: TenantDetailsFormStateTenant = new TenantDetailsFormStateTenant();
  microsoftPartner: TenantDetailsFormStateMicrosoftPartner = new TenantDetailsFormStateMicrosoftPartner();
}
